import { A4uGlobeGrid as IconComponent } from '@adobe/react-spectrum-workflow/dist/GlobeGrid.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function GlobeGrid(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}